import { create } from 'zustand'
import type { User as FirebaseUser } from 'firebase/auth'
import type { UserProfile } from '@/types/models'

type AuthState = {
  firebaseUser: FirebaseUser | null
  profile: UserProfile | null
  isLoading: boolean
  isGuest: boolean
  setFirebaseUser: (user: FirebaseUser | null) => void
  setProfile: (profile: UserProfile | null) => void
  setLoading: (loading: boolean) => void
  continueAsGuest: () => void
  clearGuest: () => void
  reset: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  firebaseUser: null,
  profile: null,
  isLoading: true,
  isGuest: false,
  setFirebaseUser: (firebaseUser) => set({ firebaseUser, isGuest: false }),
  setProfile: (profile) => set({ profile }),
  setLoading: (isLoading) => set({ isLoading }),
  continueAsGuest: () =>
    set({
      isGuest: true,
      firebaseUser: null,
      profile: null,
      isLoading: false,
    }),
  clearGuest: () => set({ isGuest: false }),
  reset: () =>
    set({
      firebaseUser: null,
      profile: null,
      isLoading: false,
      isGuest: false,
    }),
}))
